// Milliseconds in a day. This is a constant in Unix time (despite leap seconds)
const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

// Get the amount of days since the Unix time epoch
export function get_unix_day(date) {
  const milliseconds = date.getTime();
  return milliseconds / MILLISECONDS_PER_DAY;
}

export function get_date_from_unix_day(days_since_epoch) {
  const milliseconds = days_since_epoch * MILLISECONDS_PER_DAY;
  return new Date(milliseconds);
}

// At Gretel von Birne, the christmas period runs from 21 december until 3
// january. A night belongs to the christmas period if it *starts* within it,
// so the last christmas night is the one from 3 january to 4 january.
export function is_christmas_period(date) {
  const month = date.getUTCMonth();
  const day = date.getUTCDate();
  if (month === 11)
    return day >= 21;
  if (month === 0)
    return day <= 3;
  return false;
}

export function get_nights_between(start_date, end_date) {
  if (typeof start_date === "string")
    start_date = new Date(start_date);
  if (typeof end_date === "string")
    end_date = new Date(end_date);
  const start_day = get_unix_day(start_date);
  const end_day = get_unix_day(end_date);
  return end_day - start_day;
}

// Returns [nights, christmas_nights]. `christmas_nights` is the amount of
// nights that fall within the christmas period, and is included in `nights`.
export function get_nights_info(start_date, end_date) {
  const nights = get_nights_between(start_date, end_date);
  if (!Number.isFinite(nights) || nights <= 0 || nights > 365)
    return [nights, 0];

  if (typeof start_date === "string")
    start_date = new Date(start_date);
  const start_day = get_unix_day(start_date);

  // This isn't the most efficient way to do it, but it's the easiest
  // *correct* way of doing it.
  let christmas_nights = 0;
  for (let day = start_day; day < start_day + nights; day++)
    if (is_christmas_period(get_date_from_unix_day(day)))
      christmas_nights += 1;

  return [nights, christmas_nights];
}
